import * as React from 'react';
import { observer } from 'mobx-react';
import WeekStartDay from './WeekStartDay';
import saveWeekStartDayQuickSetting from '../orchestration/saveWeekStartDayQuickSetting';
var styles = require('./AppearanceQuick.scss');
/**
 * Wrapper component which renders the individual settings inside calendar appearance option
 */
export default observer(function AppearanceQuick() {
    return (React.createElement("div", { className: styles.appearanceWrapper },
        React.createElement(WeekStartDay, { showQuickSettingLabel: true, saveWeekStartDayQuickSetting: saveWeekStartDayQuickSetting })));
});
//# sourceMappingURL=AppearanceQuick.js.map